export interface DashboardChartDataModel {
  options: {
    chart: {
      type: string;
      height: string;
      width: string;
      toolbar: {
        show: boolean;
      };
      zoom: {
        enabled: boolean;
      };
      fontFamily: string | null;
      foreColor: string;
      sparkline: {
        enabled: boolean;
      };
      stacked: boolean;
    };
    plotOptions: {
      bar: {
        horizontal: boolean;
      };
    };
    colors: string[];
    series: any[];
    dataLabels: {
      enabled: boolean;
    };
    theme: {
      mode: string;
    };
    title: {
      text: string;
    };
    subtitle: {
      text: string;
      align: string;
    };
    xaxis: {
      categories: any;
    };
    grid: {
      show: boolean;
    };
    markers: {
      show: boolean;
    };
    legend: {
      show: boolean;
    };
    labels: string[];
  };
  view_url: string;
}

export interface DashboardCountChartModel {
  title: string;
  total: number;
}

export interface DashboardKRITrendDataModel {
  title: string;
  trend: KRITrendModel[];
  status: string;
}

export interface KRITrendModel {
  label: string;
  color: string;
}

export interface DashboardFilterDataModel {
  groups: DashboardFilterModel[];
  projects: DashboardFilterModel[];
  entities: DashboardFilterModel[];
  positions: DashboardFilterModel[];
  risk_types: DashboardFilterModel[];
  risk_category_parents: DashboardFilterModel[];
  risk_category_childs: DashboardFilterModel[];
}

export interface DashboardFilterModel {
  key: string;
  value: string;
}

export interface Organization {
  id: number
  ulid: string
  code: string
  name: string
  parent_id: number
  group_id?: number
  group_ulid?: string
  level: number
}

export interface TingkatRisiko {
  E: E
  T: T
  MT: Mt
  M: M
  RM: Rm
  R: R
}

export interface E {
  total: number
  percentage: number
}

export interface T {
  total: number
  percentage: number
}

export interface Mt {
  total: number
  percentage: number
}

export interface M {
  total: number
  percentage: number
}

export interface Rm {
  total: number
  percentage: number
}

export interface R {
  total: number
  percentage: number
}

export interface DashboardModel {
  main: {
    data: DashboardKRITrendDataModel[];
  };
  kriTrend: {
    data: DashboardKRITrendDataModel[];
  };
  /* Chart RCSA */
  rcsaProgress: {
    data: any[];
  };
  rcsaMonitoringProgress: {
    data: any[];
  };
  statusIru: {
    data: any[];
  };
  pemantauanIru: {
    data: any[];
  };
  pesebaranTingkatRisiko: {
    data: any[];
  };
  tingkatRisikoTarget: {
    data: TingkatRisiko;
  };
  tingkatRisikoInherent: {
    data: TingkatRisiko;
  };
  tingkatRisikoEksisting: {
    data: TingkatRisiko;
  };
  rcsaTotalOfficer: {
    data: DashboardCountChartModel;
  };
  rcsaTotalDivision: {
    data: DashboardCountChartModel;
  };
  rcsaTotalRisk: {
    data: DashboardCountChartModel;
  };
  /* Global Chart */
  riskByType: {
    data: DashboardChartDataModel;
  };
  riskProgressWorkUnit: {
    data: DashboardChartDataModel;
  };
  riskByCategory: {
    data: DashboardChartDataModel;
  };
  riskMonitoringStatus: {
    data: DashboardChartDataModel;
  };
  riskMonitoringMitigationStatus: {
    data: DashboardChartDataModel;
  };
  /* Chart KRI */
  kriTrendList: {
    data: any[];
  };
  kriProgress: {
    data: any[];
  };
  iruProgress: {
    data: any[];
  };
  kriReportResult: {
    data: DashboardChartDataModel;
  };
  kriMonitoringStatus: {
    data: DashboardChartDataModel;
  };
  kriMonitoringMitigationStatus: {
    data: DashboardChartDataModel;
  };
  /* Chart LED */
  ledTotalIncident: {
    data: DashboardCountChartModel;
  };
  ledTotalActualLosses: {
    data: DashboardCountChartModel;
  };
  ledProgressWorkUnit: {
    data: DashboardChartDataModel;
  };
  ledProgress: {
    data: any[];
  };
  ledTotalLossesPerUnit: {
    data: DashboardChartDataModel;
  };
  ledTop: {
    data: DashboardKRITrendDataModel[];
  };
  ledMonitoringStatus: {
    data: DashboardChartDataModel;
  };
  ledMonitoringMitigationStatus: {
    data: DashboardChartDataModel;
  };
  /* Filter Chart */
  filterDashboard: {
    data: DashboardFilterDataModel;
  };
  direktorat: {
    data: Organization[]
  },
  divisi: {
    data: Organization[]
  },
  departemen: {
    data: Organization[]
  },
  // Skor Efektivitas
  gambaranUmum: {
    data: any[]
  },
  gambaranKhusus: {
    data: any[],
    total: number,
  }
  gambaranKhususAllDept: {
    data: any[],
    total: number,
  }
}

export enum DashboardActionType {
  /* RCSA Chart */
  GetKRITrend = "⌘➝Dashboard➝GetKRITrend",
  GetDashboardChart = "⌘➝Dashboard➝GetDashboardChart",
  GetRiskProgress = "⌘➝Dashboard➝GetRiskProgress",
  GetStatusIRU = "⌘➝Dashboard➝GetStatusIRU",
  GetPemantauanIRU = "⌘➝Dashboard➝GetPemantauanIRU",
  GetRcsaProgress = "⌘➝Dashboard➝GetRcsaProgress",
  GetRcsaMonitoringProgress = "⌘➝Dashboard➝GetRcsaMonitoringProgress",
  GetPesebaranTingkatRisiko = "⌘➝Dashboard➝GetPesebaranTingkatRisiko",
  GetTingkatRisikoTarget = "⌘➝Dashboard➝GetTingkatRisikoTarget",
  GetTingkatRisikoInherent = "⌘➝Dashboard➝GetTingkatRisikoInherent",
  GetTingkatRisikoEksisting = "⌘➝Dashboard➝GetTingkatRisikoEksisting",
  GetRiskByType = "⌘➝Dashboard➝GetRiskByType",
  GetRiskProgressWorkUnit = "⌘➝Dashboard➝GetRiskProgressWorkUnit",
  GetRiskByCategory = "⌘➝Dashboard➝GetRiskByCategory",
  GetRiskMonitoringStatus = "⌘➝Dashboard➝GetRiskMonitoringStatus",
  GetRiskMonitoringMitigationStatus = "⌘➝Dashboard➝GetRiskMonitoringMitigationStatus",
  /* Count Chart */
  GetRiskTotalOfficer = "⌘➝Dashboard➝GetRiskTotalOfficer",
  GetRiskTotalDivision = "⌘➝Dashboard➝GetRiskTotalDivision",
  GetRiskTotalRisk = "⌘➝Dashboard➝GetRiskTotalRisk",
  /* KRI Chart */
  GetKRIProgress = "⌘➝Dashboard➝GetKRIProgress",
  GetIRUProgress = "⌘➝Dashboard➝GetIRUProgress",
  GetKRIReportResult = "⌘➝Dashboard➝GetKRIReportResult",
  GetKRIMonitoringStatus = "⌘➝Dashboard➝GetKRIMonitoringStatus",
  GetKRIMonitoringMitigationStatus = "⌘➝Dashboard➝GetKRIMonitoringMitigationStatus",
  GetKRITrendList = "⌘➝Dashboard➝GetKRITrendList",
  /* LED Chart */
  GetLEDTotalIncident = "⌘➝Dashboard➝GetLEDTotalIncident",
  GetLEDTotalActualLosses = "⌘➝Dashboard➝GetLEDTotalActualLosses",
  GetLEDProgressWorkUnit = "⌘➝Dashboard➝GetLEDProgressWorkUnit",
  GetLEDProgress = "⌘➝Dashboard➝GetLEDProgress",
  GetLEDTotalLossesPerUnit = "⌘➝Dashboard➝GetLEDTotalLossesPerUnit",
  GetTopLED = "⌘➝Dashboard➝GetTopLED",
  GetLEDMonitoringStatus = "⌘➝Dashboard➝GetLEDMonitoringStatus",
  GetLEDMonitoringMitigationStatus = "⌘➝Dashboard➝GetLEDMonitoringMitigationStatus",

  /* Filter Chart */
  GetFilterDashboard = "⌘➝Dashboard➝GetFilterDashboard",
  GetDirektorat = "⌘➝Dashboard➝GetDirektorat",
  GetDivisi = "⌘➝Dashboard➝GetDivisi",
  GetDepartemen = "⌘➝Dashboard➝GetDepartemen",

  // Skor Efektivitas
  GetGambaranUmum = "⌘➝Dashboard➝GetGambaranUmum",
  GetGambaranKhusus = "⌘➝Dashboard➝GetGambaranKhusus",
  GetGambaranKhususAllDept = "⌘➝Dashboard➝GetGambaranKhususAllDept",
}

export type DashboardAction =
  | {
      data: {
        data: DashboardKRITrendDataModel[];
      };
      type: DashboardActionType.GetDashboardChart;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetKRITrend;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetRiskProgress;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetRcsaMonitoringProgress;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetStatusIRU;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetPemantauanIRU;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetPesebaranTingkatRisiko;
    }
  | {
      data: {
        data: TingkatRisiko;
      };
      type: DashboardActionType.GetTingkatRisikoTarget;
    }
  | {
      data: {
        data: TingkatRisiko;
      };
      type: DashboardActionType.GetTingkatRisikoInherent;
    }
  | {
      data: {
        data: TingkatRisiko;
      };
      type: DashboardActionType.GetTingkatRisikoEksisting;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetRiskByType;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetRiskProgressWorkUnit;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetRiskByCategory;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetRiskMonitoringStatus;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetRiskMonitoringMitigationStatus;
    }
  | {
      data: {
        data: DashboardCountChartModel;
      };
      type: DashboardActionType.GetRiskTotalOfficer;
    }
  | {
      data: {
        data: DashboardCountChartModel;
      };
      type: DashboardActionType.GetRiskTotalDivision;
    }
  | {
      data: {
        data: DashboardCountChartModel;
      };
      type: DashboardActionType.GetRiskTotalRisk;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetKRIProgress;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetIRUProgress;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetKRIMonitoringStatus;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetKRIMonitoringMitigationStatus;
    }
  | {
      data: {
        data: DashboardKRITrendDataModel[];
      };
      type: DashboardActionType.GetKRITrendList;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetKRIReportResult;
    }
  | {
      data: {
        data: DashboardCountChartModel;
      };
      type: DashboardActionType.GetLEDTotalIncident;
    }
  | {
      data: {
        data: DashboardCountChartModel;
      };
      type: DashboardActionType.GetLEDTotalActualLosses;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetLEDProgressWorkUnit;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetLEDProgress;
    }
  | {
      data: {
        data: [];
      };
      type: DashboardActionType.GetLEDTotalLossesPerUnit;
    }
  | {
      data: {
        data: DashboardKRITrendDataModel[];
      };
      type: DashboardActionType.GetTopLED;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetLEDMonitoringStatus;
    }
  | {
      data: {
        data: DashboardChartDataModel;
      };
      type: DashboardActionType.GetLEDMonitoringMitigationStatus;
    }
  | {
      data: {
        data: DashboardFilterDataModel;
      };
      type: DashboardActionType.GetFilterDashboard;
    }
  | {
      data: {
        data: Organization[];
      };
      type: DashboardActionType.GetDirektorat;
    }
  | {
      data: {
        data: Organization[];
      };
      type: DashboardActionType.GetDivisi;
    }
  | {
      data: {
        data: Organization[];
      };
      type: DashboardActionType.GetDepartemen;
    }
  | {
      data: {
        data: any[];
      };
      type: DashboardActionType.GetGambaranUmum;
    }
  | {
      data: {
        data: any[];
        total: number
      };
      type: DashboardActionType.GetGambaranKhusus;
    }
  | {
      data: {
        data: any[];
        total: number
      };
      type: DashboardActionType.GetGambaranKhususAllDept;
    }
